import { useCallback, useMemo } from "react";
import { t } from "@/i18n-js/instance";
import { useBlock } from "./useBuilderStore";

const i18nRoot = "builder_ui.layers.actions";

export const useLayerBlockActions = (blockId: string) => {
  const {
    canMoveUp,
    canMoveDown,
    moveBlock,
    removeBlock,
    duplicateBlock,
    resetBlockStyle,
    copyBlockId,
  } = useBlock(blockId);

  const onRemoveHandler = useCallback(() => {
    // TODO: Add confirmation modal
    removeBlock();
  }, [removeBlock]);

  return useMemo(
    () => [
      {
        label: t([i18nRoot, "move_up"]),
        value: "move_up",
        isDisabled: !canMoveUp,
        onClick: () => moveBlock("up"),
      },
      {
        label: t([i18nRoot, "move_down"]),
        value: "move_down",
        isDisabled: !canMoveDown,
        onClick: () => moveBlock("down"),
      },
      {
        value: "separator" as const,
      },
      {
        label: t([i18nRoot, "copy_block_id"]),
        value: "copy_block_id",
        onClick: copyBlockId,
      },
      {
        label: t([i18nRoot, "duplicate"]),
        value: "duplicate",
        onClick: duplicateBlock,
      },
      /* TODO: To be implemented
      {
        label: t([i18nRoot, "rename"]),
        value: "rename",
        onClick: () => {},
      }, */
      {
        value: "separator" as const,
      },
      /* TODO: To be implemented
      {
        label: t([i18nRoot, "hide"]),
        value: "hide",
        onClick: () => {},
      }, */
      {
        label: t([i18nRoot, "reset_styles"]),
        value: "reset_styles",
        color: "text-v2-danger",
        onClick: resetBlockStyle,
      },
      {
        label: t([i18nRoot, "delete"]),
        value: "remove",
        color: "text-v2-danger",
        onClick: onRemoveHandler,
      },
    ],
    [
      canMoveDown,
      canMoveUp,
      duplicateBlock,
      moveBlock,
      resetBlockStyle,
      onRemoveHandler,
      copyBlockId,
    ],
  );
};
